export default "__VITE_ASSET__CtEOVAnh__"